module.exports = __webpack_public_path__ + "img/dapper.af6a68db.png";